import { Button } from 'antd'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components/macro'

const OllieChatInput = ({
  onSend,
  disabled = false,
  isSending = false,
  placeholder = 'Ask Ollie anything about OMS…',
  draft = '',
  onDraftConsumed,
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    if (!draft) {
      return
    }
    setValue(draft)
    onDraftConsumed?.()
  }, [draft, onDraftConsumed])

  const handleSubmit = () => {
    const trimmed = value.trim()
    if (!trimmed || disabled || isSending) {
      return
    }
    onSend(trimmed)
    setValue('')
  }

  const handleKeyDown = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      handleSubmit()
    }
  }

  return (
    <Wrapper>
      <TextArea
        value={value}
        onChange={event => setValue(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled || isSending}
        rows={2}
      />
      <SendButton
        type='primary'
        onClick={handleSubmit}
        disabled={disabled || isSending || !value.trim()}
        loading={isSending}
      >
        Send
      </SendButton>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  padding: 12px 16px 8px;
  background: ${({ theme }) => theme.colours.mayoWhite};
`

const TextArea = styled.textarea`
  flex: 1;
  resize: none;
  border: 1px solid ${({ theme }) => theme.colours.panSilver};
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.4;
  font-family: inherit;
  min-height: 44px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colours.lettuceGreen};
  }

  &:disabled {
    background: ${({ theme }) => theme.colours.bgGrey};
    cursor: not-allowed;
  }
`

const SendButton = styled(Button)`
  && {
    background: ${({ theme }) => theme.colours.lettuceGreen};
    border-color: ${({ theme }) => theme.colours.lettuceGreen};
    color: ${({ theme }) => theme.colours.bbqBlack};
    font-weight: 600;
    height: 44px;
    min-width: 72px;
  }

  &&:hover,
  &&:focus {
    background: ${({ theme }) => theme.colours.avocadoGreen};
    border-color: ${({ theme }) => theme.colours.avocadoGreen};
    color: ${({ theme }) => theme.colours.bbqBlack};
  }

  &&[disabled] {
    background: ${({ theme }) => theme.colours.panSilver};
    border-color: ${({ theme }) => theme.colours.panSilver};
    color: ${({ theme }) => theme.colours.oliveGrey};
  }
`

export default OllieChatInput
